export const SIMPLE_CODE_EDITOR_STYLE_DEFAULT = {
  fontFamily: '"Fira code", "Fira Mono", monospace',
  fontSize: 12,
  border: '1px solid #ced4da',
  borderRadius: '0.25rem',
};
